export default __webpack_public_path__ + "static/media/gallery-4.b2ea3408.jpg";